const SENTRY_LOG_PREFIX = '@GW: '
export function logSentry(...messages: Parameters<typeof console.debug>) {
  console.debug(SENTRY_LOG_PREFIX, ...messages)
}

export function isSentryLogMessage(message: string | undefined) {
  return message?.startsWith(SENTRY_LOG_PREFIX)
}
